import { FC } from 'react';
import MainLayout from 'components/main-layout/MainLayout';

const Screen: FC = () => {
  return <MainLayout title="Управление на пакети с документи">списък</MainLayout>;
};

export default Screen;
